<template>
  <div class="French bg-pink h-screen">
    <div id="total-container" class="h-full w-full relative overflow-hidden">
      <!-- stripes container -->
      <div class="stripes-container absolute h-full w-full 2xl:mt-64 border?">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-red.png" alt="red stroke" class="animate first-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeOneClass : 'animate__delay-2500ms?slide-in-blurred-right']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-white.png" alt="white stroke" class="animate second-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeTwoClass : 'animate__delay-2750ms?slide-in-blurred-right']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-blue.png" alt="blue stroke" class="animate third-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeThreeClass : 'animate__delay-1500ms?slide-in-blurred-right']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-red.png" alt="red stroke" class="animate forth-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeFourClass : 'animate__delay-4s?slide-in-blurred-left']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-white.png" alt="white stroke" class="animate fifth-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeFiveClass : 'animate__delay-1s?slide-in-blurred-left']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-blue.png" alt="blue stroke" class="animate sixth-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeSixClass : 'animate__delay-2s?slide-in-blurred-left']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-red.png" alt="red stroke" class="animate seventh-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeSevenClass : 'animate__delay-3500ms?slide-in-blurred-right']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-white.png" alt="white stroke" class="animate eighth-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeEightClass : '?slide-in-blurred-left']">

        <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Stroke-blue.png" alt="blue stroke" class="animate ninth-stripe paint-stroke absolute"
        :class="[stripes.allStripesLoaded ? stripes.stripeNineClass : 'animate__delay-3s?slide-in-blurred-left ']">

      </div>
      <!-- stars container -->
      <div class="stars-container absolute h-full w-full border? 2xl:mt-32">
        <div class="w-40 mx-auto">
          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/star01.png" alt="first star" id="first-star" class="star w-40 absolute animate"
          :class="[stars.starOneShake ? stars.starOneClasses : '', stars.allStarsLoaded ? '' : 'star-fade-in?animate__delay-3500ms']">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/star02.png" alt="second star" id="second-star" class="star w-40 ml-6 absolute animate"
          :class="[stars.starTwoShake ? stars.starTwoClasses : '', stars.allStarsLoaded ? '' : 'star-fade-in?animate__delay-5s']">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/star01.png" alt="third star" id="third-star" class="star third-star w-40 -ml-2 absolute animate"
          :class="[stars.starThreeShake ? stars.starThreeClasses : '', stars.allStarsLoaded ? '' : 'star-fade-in?animate__delay-4s']">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/star02.png" alt="forth star" id="forth-star" class="star forth-star w-40 ml-2 absolute animate"
          :class="[stars.starFourShake ? stars.starFourClasses : '', stars.allStarsLoaded ? '' : 'star-fade-in?animate__delay-3s']">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/star02.png" alt="fifth star" id="fifth-star" class="star fifth-star w-40 absolute animate"
          :class="[stars.starFiveShake ? stars.starFiveClasses : '', stars.allStarsLoaded ? '' : 'star-fade-in?animate__delay-4500ms']">
        </div>
      </div>
      <!-- gifs container -->
      <div class="gifs-container flex absolute h-full w-full">
        <div :class="[gifs.activated ? 'z-50' : 'z-0']" class="gifs-images-container m-auto border?">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Deep-Info.gif" alt="deep Info gif" :class="[gifs.DeepInfo ? '' : 'hidden']"
          class="DeepInfoGif animate scale-up-fast-center gif-width">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Show.gif" alt="the show gif" :class="[gifs.Show ? '' : 'hidden']"
          class="ShowGif animate scale-up-fast-center gif-width">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Invitation.gif" alt="Invitation Gif" :class="[gifs.Invitation ? '' : 'hidden']"
          class="InvitationGif animate scale-up-fast-center gif-width">

          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/Book.gif" alt="ForMarkOnly Gif" :class="[gifs.ForMarkOnly ? '' : 'hidden']"
          class="ForMarkOnlyGif animate scale-up-fast-center gif-width">

        </div>
      </div>
      <!-- clouds container -->
      <div class="clouds-container absolute h-full w-full 2xl:mt-32 z-40">
        <div class="cloud-images-container mx-auto pt-12?">
          <img @click="clickedCloud('ForMarkOnly')" src="https://blissing.s3-us-west-1.amazonaws.com/img/Mark.png" alt="for mark only cloud"
          :class="[cloudsGrowing ? cloudsGrowingClasses.mark : pulsingClasses.standard]"
          class="mark-cloud w-full mt-12 cursor-pointer">

          <img @click="clickedCloud('Show')" src="https://blissing.s3-us-west-1.amazonaws.com/img/Show.png" alt="show cloud"
          :class="[cloudsGrowing ? cloudsGrowingClasses.show : pulsingClasses.longestDelay]"
          class="invitation-cloud w-full cursor-pointer">

          <img @click="clickedCloud('Invitation')" src="https://blissing.s3-us-west-1.amazonaws.com/img/Invitation.png" alt="Invitation cloud"
          :class="[cloudsGrowing ? cloudsGrowingClasses.invitation : pulsingClasses.longerDelay]"
          class="show-cloud w-full cursor-pointer">

          <img @click="clickedCloud('DeepInfo')" src="https://blissing.s3-us-west-1.amazonaws.com/img/DeepInfo.png" alt="deep info cloud"
          :class="[cloudsGrowing ? cloudsGrowingClasses.deepInfo : pulsingClasses.shortDelay]"
          class="deep-info-cloud w-full cursor-pointer">
        </div>
      </div>
      <!-- blissing logo  -->
      <div class="logo-placement w-32 mx-auto z-30 absolute bottom-0 w-full">
        <div class="mr-20 logo-container">
          <img src="https://blissing.s3-us-west-1.amazonaws.com/img/BlissingLogo_tilted.png" alt="Blissing logo tilted" :class="[logoShouldFadeIn ? logoFadeClasses : logoTeaseClasses]"
          class="blissing-logo w-32 mx-auto">
        </div>
      </div>


      <div class="contact-link w-32 mx-auto z-50 absolute bottom-0 w-full">
        <div class="mr-0">
          <router-link to="/contact" class="text-4xl text-black font-bold cursor-pointer">CONTACT</router-link>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "Start",
  data(){
    return{
      activateLoop: false,
      cloudsGrowing: false,
      cloudsGrowingClasses:{
        mark: 'animate scale-up-center animate__delay-5s',
        invitation: 'animate scale-up-center animate__delay-5s',
        show: 'animate scale-up-center animate__delay-6s',
        deepInfo: 'animate scale-up-center animate__delay-5500ms',
      },
      pulsingClasses:{
        standard: 'fe-pulse',
        shortDelay: 'fe-pulse animate animate__delay-1s',
        longerDelay: 'fe-pulse animate animate__delay-2s',
        longestDelay: 'fe-pulse animate animate__delay-3s',
      },
      logoShouldFadeIn: true,
      logoFadeClasses: 'animate fade-in animate__delay-1s',
      logoTeaseClasses: 'skew-it',
      stripes:{
        allStripesLoaded: true,
        stripeOneClass: '',
        stripeTwoClass: '',
        stripeThreeClass: '',
        stripeFourClass: '',
        stripeFiveClass: '',
        stripeSixClass: '',
        stripeSevenClass: '',
        stripeEightClass: '',
        stripeNineClass: '',
      },
      stars:{
        allStarsLoaded: false,
        starOneShake: false,
        starTwoShake: false,
        starThreeShake: false,
        starFourShake: false,
        starFiveShake: false,
        starOneClasses: 'rotate-50-cw-double',
        starTwoClasses: 'rotate-50-cw',
        starThreeClasses: 'rotate-50-cw',
        starFourClasses: 'rotate-50-cw',
        starFiveClasses: 'down-up-star',
      },
      gifs:{
        activated: false,
        DeepInfo: false,
        Show: false,
        Invitation: false,
        ForMarkOnly: false
      }
    }
  },
  methods:{
    clickedCloud(routeName){
      //activate and show gif
      this.gifs.activated = true;
      this.gifs[routeName] = true;

      // wait for the animation to finish and then change the page...
      const animatedGif = document.querySelector('.' + routeName + 'Gif');

      animatedGif.addEventListener('animationend', () => {

        if (routeName !== 'Show' && routeName !== 'ForMarkOnly') {

          setTimeout(() =>{
            this.$router.push({name: routeName});
          }, 1500);


        } else if (routeName === 'Show') {
          //if the show page is clicked we should hide the show gif
          setTimeout(() =>{
            this.gifs.Show = false;
            //stop the music
            Event.$emit('stopAudio');

            // and open in new window
            window.open(this.showVideoUrl);
          }, 1500);

        } else if (routeName === 'ForMarkOnly') {
          setTimeout(() =>{
            this.gifs.ForMarkOnly = false;
            Event.$emit('stopAudio');
            window.open(this.pdfBaseUrl + this.forMarkOnlyPdf);
          }, 1500);
        }

      });

    },
    loopAnimations(counter){
        if (this.activateLoop) {

         // console.log( counter );

         counter++;

         if (counter == 0) {
           // reset stars
           this.stars.starThreeShake = false;
           this.stars.starOneShake = false;
           this.stars.starTwoShake = false;
           this.stars.starThreeShake = false;
           this.stars.starFourShake = false;
           this.stars.starFiveShake = false;
         }

         if (counter == 1) {
           // reset stripes
           this.stripes.stripeOneClass = '';
           this.stripes.stripeTwoClass = '';
           this.stripes.stripeThreeClass = '';
           this.stripes.stripeFourClass = '';
           this.stripes.stripeFiveClass = '';
           this.stripes.stripeSixClass = '';
           this.stripes.stripeSevenClass = '';
           this.stripes.stripeEightClass = '';
           this.stripes.stripeNineClass = '';

           this.stars.starOneShake = true;
         }

         if (counter == 2) {
           this.stars.starTwoShake = true;
         }

         if (counter == 3) {
           this.stripes.stripeThreeClass = 'shake-horizontal';
         }

         // if (counter == 4) {
         //
         // }

         if (counter == 5) {
           this.stripes.stripeThreeClass = '';
           this.stars.starThreeShake = true;
         }

         // if (counter == 6) {
         //
         // }

         if (counter == 7) {
           this.stars.starOneShake = true;
         }

         // if (counter == 8) {
         //
         // }

         if (counter == 9) {
           this.stars.starFiveShake = true;
         }

         // if (counter == 10) {
         //
         // }

         if (counter == 11) {
           this.stripes.stripeThreeClass = 'slide-out-and-in-right';
         }

         // if (counter == 12) {
         //
         // }

         if (counter == 13) {

           // reset stars
           this.stars.starThreeShake = false;
           this.stars.starOneShake = false;
           this.stars.starTwoShake = false;
           this.stars.starThreeShake = false;
           this.stars.starFourShake = false;
           this.stars.starFiveShake = false;

           this.stars.starTwoShake = true;
           this.logoTeaseClasses = 'vibrate-1';
         }

         if (counter == 14) {
           this.stars.starTwoShake = false;

           this.stars.starThreeShake = true;
           this.logoTeaseClasses = 'skew-it';
         }

         if (counter == 15) {
           this.stars.starThreeShake = false;

           this.stripes.stripeTwoClass = 'slide-out-and-in-left';
         }

         if (counter == 16) {
           this.stars.starThreeShake = true;
         }
         //
         if (counter == 17) {
           this.stars.starThreeShake = false;

         this.stars.starFiveShake = true;
         }

         if (counter == 18) {
           this.stripes.stripeFiveClass = 'change-height';
         }

         if (counter == 19) {
           this.stripes.stripeSevenClass = 'slide-out-and-in-left';
           this.stars.starOneShake = true;
         }

         if (counter == 20) {

           // reset stripes
           this.stripes.stripeOneClass = '';
           this.stripes.stripeTwoClass = '';
           this.stripes.stripeThreeClass = '';
           this.stripes.stripeFourClass = '';
           this.stripes.stripeFiveClass = '';
           this.stripes.stripeSixClass = '';
           this.stripes.stripeSevenClass = '';
           this.stripes.stripeEightClass = '';
           this.stripes.stripeNineClass = '';

           this.stars.starFourShake = true;
         }

         if (counter == 21) {
           this.stars.starFourShake = false;
         }

         if (counter == 22) {
           this.stripes.stripeOneClass = 'change-height';
         }
         //
         if (counter == 23) {
         this.stars.starTwoShake = true;
         }

         if (counter == 24) {
           this.logoTeaseClasses = 'vibrate-1';
           this.stripes.stripeNineClass = 'slide-out-and-in-right-2x';
         }

         if (counter == 25) {
           this.logoTeaseClasses = 'skew-it';
         }

         if (counter == 26) {
           this.logoTeaseClasses = 'flicker-1';
         }

         if (counter == 27) {
         this.stars.starThreeShake = true;
         }
         //
         if (counter == 28) {
         this.stars.starfiveShake = true;
         }

         if (counter == 29) {
           this.stripes.stripeTwoClass = 'shake-horizontal';
         }


         if (counter == 30) {
           this.logoTeaseClasses = 'skew-it';
           this.stripes.stripeTwoClass = '';
           counter = 0;
         }

         window.setTimeout( () => {
            this.loopAnimations(counter);
         }, 1000)

      }
    },
    updateLogoAnimation(){
      //switches the animation to the subtle tease
      this.logoShouldFadeIn = false;

      this.loopAnimations(0);

    },
    initStarShakes(){

      this.stars.allStarsLoaded = true;

    }
  },
  mounted(){

    Event.$emit('playAudio', 'Start');

    this.activateLoop = true;

    // clouds

    const animatedCloud = document.querySelector('.mark-cloud');

    animatedCloud.addEventListener('animationend', () => {
      this.cloudsGrowing = false;
    });

    // blissing logo

    const animatedLogo = document.querySelector('.blissing-logo');

    animatedLogo.addEventListener('animationend', () => {
      this.updateLogoAnimation()
    });

    // all stars loaded...
    const fifthAnimatedStar = document.querySelector('.fifth-star');

    fifthAnimatedStar.addEventListener('animationend', () => {
      this.initStarShakes();
    });

    // all stripes loaded...
    const lastAnimatedStripe = document.querySelector('.forth-stripe');

    lastAnimatedStripe.addEventListener('animationend', () => {
      this.stripes.allStripesLoaded = true;
    });

  },
  computed: {
     ...mapState(["showVideoUrl", "pdfBaseUrl", "forMarkOnlyPdf"])
   },
  beforeDestroy(){
    this.activateLoop = false;
  }
}
</script>

<style lang="css" scoped>

</style>
